module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_3016.2dfcc1c6.png";